import {isEmpty} from "@/util/Helpers";

const getDefaultState = () => {
    return {
        isAuthenticated: false,
        csCookie: null,
        sessionCookie: null,
        authProfile: null,
        lastDpkSyzygos: null
    }
}

export const namespaced = true
export const state = getDefaultState()

export const mutations = {
    SET_COOKIES(state, data) {
        state.csCookie = data.cookies.csCookie
        state.sessionCookie = data.cookies.sessionCookie
    },
    SET_AUTH(state, data) {
        state.authProfile = data.data
        state.isAuthenticated = data.isAuthenticated
    },
    SET_LAST_DPK_SYZYGOS(state, data) {
        state.lastDpkSyzygos = data
    },
    RESET_STATE(state) {
        Object.assign(state, getDefaultState())
    },
}
export const actions = {
    updateCookies({commit}, cookies) {
        commit('SET_COOKIES', cookies)
    },
    updateAuth({commit}, data) {
        commit('SET_AUTH', data)
    },
    updateLastDpkSyzygos({commit}, data) {
        commit('SET_LAST_DPK_SYZYGOS', data)
    },
    resetState({commit}) {
        commit('RESET_STATE')
    },
}

export const getters = {
    getT141Id(state) {
        return !isEmpty(state.authProfile) ? state.authProfile.t141Id : null
    },
    getCsCookies(state) {
        return state.csCookie
    },

    isAuthenticated(state) {
        return state.isAuthenticated;
    },

    getProfile(state) {
        return !isEmpty(state.authProfile) ? state.authProfile : null
    }
}

